import { render, staticRenderFns } from "./timeout-order-fee-standards.vue?vue&type=template&id=9ab1e834&scoped=true&"
import script from "./timeout-order-fee-standards.vue?vue&type=script&lang=js&"
export * from "./timeout-order-fee-standards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab1e834",
  null
  
)

export default component.exports